import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { RowItems } from '../../models/TableProps';
import { CartLineItem } from '../../models/Cart';
import { Box, styled, Typography } from '@mui/material';
import { QuantitySelector } from '../shared/QuantitySelector';
import { getCurrency, getNetPrice } from '../../utils/utils';
import { formatPrice } from '../../utils/numberFormatter';

const StyledImage = styled(Box)(() => ({
    width: '90px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
        maxWidth: '100%',
    },
}));

export const CartTableRow: React.FC<RowItems<CartLineItem>> = (props) => {
    const { row, index, handleChange } = props;
    const labelId = `enhanced-table-checkbox-${index}`;

    const handleQtyChange = (qty) => {
        handleChange({
            qty: qty,
            rowID: row.id,
            remove: false,
        });
    };

    const handleDelete = () => {
        handleChange({
            qty: 0,
            rowID: row.id,
            remove: true,
        });
    };

    return (
        <TableRow>
            <TableCell id={labelId} sx={{ width: '50%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ paddingRight: '10px' }}>
                        <StyledImage>
                            <img
                                src={row.merchandise.product.featuredImage.url}
                            />
                        </StyledImage>
                    </Box>
                    <Box>
                        <Typography>{row.merchandise.product.title}</Typography>
                        <Typography>{row.merchandise.sku}</Typography>
                    </Box>
                </Box>
            </TableCell>
            <TableCell id={labelId}>
                {formatPrice(
                    getNetPrice(Number(row.cost.amountPerQuantity.amount))
                )}{' '}
                {getCurrency(row.cost.amountPerQuantity.currencyCode)}
            </TableCell>
            <TableCell id={labelId} sx={{ width: '150px' }}>
                <QuantitySelector
                    variant={row.merchandise}
                    qtyChanged={handleQtyChange}
                    defaultQty={row.quantity}
                />
            </TableCell>
            <TableCell id={labelId}>
                {formatPrice(getNetPrice(Number(row.cost.totalAmount.amount)))}{' '}
                {getCurrency(row.cost.totalAmount.currencyCode)}
            </TableCell>
            <TableCell id={labelId}>
                <Typography onClick={handleDelete} sx={{ cursor: 'pointer' }}>
                    X
                </Typography>
            </TableCell>
        </TableRow>
    );
};
